// https://bcfregression-forddirectnative.cms.dealer.com/cpov.htm
//
// The "Search Inventory" CTA on the Ford Blue Advantage CPO page.
//
// This replaces the `ford-blue-advantage-search-inventory` entry that used to
// live in event/utils/linkTypeSelectors.js + linkTypeMapping.js. That pair could
// never fire: the selector was correct and did match the element, but the CTA is
// a ws-content-cta widget that emits `widgetUserEvent`, while linkTypeSelectors
// only participates in `ddc.link.generic` clicks. New Relic confirmed zero events
// fleet-wide over 90 days for that linkType, while the four brochure links on the
// same page -- which are plain anchors, so genuinely link-generic -- show healthy
// volume.
//
// No `page` block on purpose: a post-page-load event inherits both page-name
// fields by merging over window.pageLoadDigitaldata. US2066787 removed the
// redundant pageNameNoVehicle override from this key's four siblings for exactly
// that reason, so declaring one here would reintroduce what that story removed.
export default {
	events: {
		widgetUserEvent: [
			{
				logic: ({ eventData }) => {
					const { widgetName, widgetId, elementCTA } = eventData;

					return (
						widgetName === 'ws-content-cta' &&
						widgetId === 'content1' &&
						elementCTA === 'Search Inventory'
					);
				},
				payload: () => ({
					directCall: 'global-onclick',
					payload: {
						onclick: {
							onclick:
								'used:si:cpo overview blue advantage:content:search inventory',
							onclickLinkName:
								'{client}:used:si:cpo overview blue advantage:content:action'
						}
					}
				})
			}
		]
	}
};
